import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Button,
  Box
} from '@mui/material';

import VaccinesIcon from '@mui/icons-material/Vaccines';
import AssessmentIcon from '@mui/icons-material/Assessment';
import GroupIcon from '@mui/icons-material/Group';

export default function ServiceHistorySection({
  onPreventiveUpload,
  onHEDISUpload,
  onSpecialistUpload
}) {
  const handleFileUpload = (callback) => (e) => {
    const file = e.target.files[0];
    if (file?.type === 'text/plain') {
      const reader = new FileReader();
      reader.onload = (e) => callback(e.target.result);
      reader.readAsText(file);
    }
  };

  const downloadTemplate = (filename, content) => {
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Card sx={{ mb: 6 }}>
      <CardHeader title="Service and Evaluation History" sx={{ backgroundColor: '#f5f5f5' }} />
      <CardContent>
        <Grid container spacing={4}>

          {/* Preventive services */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
              <VaccinesIcon sx={{ mr: 1 }} /> Completed Preventive Services
            </Typography>
            <Box mt={1} display="flex" gap={2}>
              <Button variant="outlined" component="label">
                Upload .txt file
                <input type="file" hidden onChange={handleFileUpload(onPreventiveUpload)} accept=".txt" />
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  downloadTemplate(
                    'preventive_services_template.txt',
                    'Colonoscopy - 2023-11-10\nMammogram - 2024-03-05'
                  )
                }
              >
                Download template
              </Button>
            </Box>
          </Grid>

          {/* HEDIS metrics */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
              <AssessmentIcon sx={{ mr: 1 }} /> HEDIS Metrics
            </Typography>
            <Box mt={1} display="flex" gap={2}>
              <Button variant="outlined" component="label">
                Upload .txt file
                <input type="file" hidden onChange={handleFileUpload(onHEDISUpload)} accept=".txt" />
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  downloadTemplate(
                    'hedis_metrics_template.txt',
                    'Controlled A1c (<8%) - 2024-02-15\nHypertension control (<140/90) - 2024-01-25'
                  )
                }
              >
                Download template
              </Button>
            </Box>
          </Grid>

          {/* Specialist visits */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
              <GroupIcon sx={{ mr: 1 }} /> Specialist Visits
            </Typography>
            <Box mt={1} display="flex" gap={2}>
              <Button variant="outlined" component="label">
                Upload .txt file
                <input type="file" hidden onChange={handleFileUpload(onSpecialistUpload)} accept=".txt" />
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  downloadTemplate(
                    'specialist_visits_template.txt',
                    'Dr. Smith - Cardiology - 2024-01-20 - Post-infarction evaluation\nDr. Lopez - Endocrinology - 2024-03-10 - Diabetes control'
                  )
                }
              >
                Download template
              </Button>
            </Box>
          </Grid>

        </Grid>
      </CardContent>
    </Card>
  );
}
